/** Fixed list of regular flight windows a pilot can pick (any number). */
export const AVAILABILITY_OPTIONS = [
  {
    key: "early_am",
    label: "Early AMs",
    window: "6:00 – 8:30 AM",
    blurb: "Dawn patrol before work",
  },
  {
    key: "morning",
    label: "Mornings",
    window: "9:00 AM – 12:00 PM",
    blurb: "Mid-morning open tracks",
  },
  {
    key: "lunch_break",
    label: "Lunch Break",
    window: "12:00 – 2:00 PM",
    blurb: "A quick midday pack or two",
  },
  {
    key: "weekday_evenings",
    label: "Weekday Evenings",
    window: "5:00 – 8:00 PM",
    blurb: "After-work flight line",
  },
  {
    key: "late_evenings",
    label: "Late Evenings",
    window: "8:00 – 11:00 PM",
    blurb: "Night owls and late heats",
  },
  {
    key: "weekend_mornings",
    label: "Weekend Mornings",
    window: "Sat / Sun AM",
    blurb: "Coffee and first packs",
  },
  {
    key: "weekend_afternoons",
    label: "Weekend Afternoons",
    window: "Sat / Sun PM",
    blurb: "Long sessions, full squads",
  },
  {
    key: "chaotic",
    label: "My schedule is chaotic",
    window: "Anytime",
    blurb: "Ping me for anything",
  },
] as const;

export type AvailabilityKey = (typeof AVAILABILITY_OPTIONS)[number]["key"];
export const AVAILABILITY_KEYS = AVAILABILITY_OPTIONS.map((o) => o.key) as [
  AvailabilityKey,
  ...AvailabilityKey[],
];

export function availabilityLabel(key: string): string {
  return AVAILABILITY_OPTIONS.find((o) => o.key === key)?.label ?? key;
}

/** Union without duplicates, keeping the canonical option order. */
export function mergeAvailability(
  current: readonly string[],
  add: readonly string[],
): AvailabilityKey[] {
  const set = new Set([...current, ...add]);
  return AVAILABILITY_KEYS.filter((k) => set.has(k));
}
